import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSecureDataLink } from 'services/secureDataSharing';
import { ICreateSecureLinkPayload } from 'services/secureDataSharing/types';

export const ThunkCreateSecureDataLink = createAsyncThunk<string, ICreateSecureLinkPayload>(
  'secureDataSharing/createSecureDataLink',
  payload => createSecureDataLink(payload).then(r => r.data.data),
);
